<div class="help-btn-wrapper">
  @if (isOpen()) {
    <div class="help-menu">
      @for (option of options; track option.fileName) {
        <button type="button" class="help-menu__item" (click)="download(option)">
          {{ option.label }}
        </button>
      }
    </div>
  }

  <button
    type="button"
    class="help-btn"
    [class.help-btn--open]="isOpen()"
    (mouseenter)="isHovered.set(true)"
    (mouseleave)="isHovered.set(false)"
    (click)="toggleMenu()"
  >
    <i class="pi pi-question-circle help-btn__icon"></i>
    @if (isHovered() || isOpen()) {
      <span class="help-btn__label">¿Necesitas ayuda?</span>
    }
  </button>
</div>
